import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import MeetingRequestIndex from "./MeetingRequestIndex";
import { getPreBasePath, getPreBaseRoute } from "../../../../components";
export const getMeetingBasePath = () => "/app/meeting";
export const meetingTopicRoute = () => getMeetingBasePath() + "/topic";
export const getMeetingTeamRoute = () => getMeetingBasePath() + "/team";
export const getMeetingDetailRoute = () => getMeetingBasePath() + "/detail";
export const getMeetingTypeRoute = () => getMeetingBasePath() + "/type";
export const getMeetingSchedulerRoute = () => getMeetingBasePath() + "/scheduler";
export const getMeetingConfirmRoute = () => getMeetingBasePath() + "/confirm";
export const getMeetingRequestBaseRoute = () => "/app/meetingRequest";
export const meetingTopicPath = (params) => {
    return (getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
        meetingTopicRoute() +
        (params.studentAffiliationId
            ? "?studentAffiliationId=" + params.studentAffiliationId
            : ""));
};
export const meetingSchedulerPath = (params) => {
    return (getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) + getMeetingSchedulerRoute());
};
export const meetingDetailPath = (params) => {
    return (getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) +
        getMeetingDetailRoute() +
        "/" +
        params.meetingId);
};
export const meetingConfirmPath = (params) => {
    return getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) + getMeetingConfirmRoute();
};
export const meetingTypePath = (params) => {
    return getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) + getMeetingTypeRoute();
};
export const meetingTeamPath = (params) => {
    return getPreBasePath(params === null || params === void 0 ? void 0 : params.virtualizedAppName) + getMeetingTeamRoute();
};
const AdvisorRoutes = () => (_jsx(Switch, { children: _jsx(Route, { path: `${getPreBaseRoute() + getMeetingRequestBaseRoute()}`, component: MeetingRequestIndex }) }));
export default AdvisorRoutes;
